// Component
import MDCustomSearchFilterIcon from "containers/MonthlyDeclaration/MonthlyDeclarationCustomFilter/CustomSearchFilterIcon";

// Hooks
import { useAppDispatch, useAppSelector } from "app/hooks/hooks";
import { showHideFilter, updateCurrentGroup, toggleFilter, clearFilter } from "redux/userList/userSlice";

// Type definitions
import type { MDCustomSearchFilterIconProps } from "containers/MonthlyDeclaration/MonthlyDeclarationCustomFilter/CustomSearchFilterIcon";
import type { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import type { ReimbSummaryDataType } from "redux/types";

interface FilterItem {
	[key: string]: boolean;
}

export function useCustomSearchFilterIcon({ infoItem }: MDCustomSearchFilterIconProps) {
	const { voucher_group_code, yearmonth, reimb_summ_id } = infoItem;

	const dispatch = useAppDispatch();
	const showFilter = useAppSelector(showHideFilter);
	const filterData: FilterItem = {};
	// Group Code is used as Unique Id
	const groupCode = reimb_summ_id.toString();

	const handleToggleFilter = (groupCodeVal: string) => {
		filterData[groupCodeVal] = !showFilter[groupCodeVal];
		dispatch(clearFilter({}));
		dispatch(updateCurrentGroup(`${voucher_group_code}${yearmonth}`));
		dispatch(toggleFilter(filterData));
	};

	return { groupCode, handleToggleFilter };
}

export const generateExpandRowHeaders = (record: ReimbSummaryDataType): Array<ColumnHeaderRowType> => {
	return [
		{
			title: "Date & Time",
			dataIndex: "dateTime",
			align: "center"
		},
		{
			title: "Purchase Value",
			dataIndex: "purchaseValue",
			align: "center"
		},
		{
			title: "Receipt Number",
			dataIndex: "receiptNum",
			align: "center"
		},
		{
			title: "eVoucher Number",
			dataIndex: "eVoucherNum",
			align: "center"
		},
		{
			title: "eVoucher Value",
			dataIndex: "eVoucherValue",
			align: "center"
		},
		{
			title: "eVoucher Qty",
			dataIndex: "eVoucherQty",
			align: "center"
		},
		{
			title: "eVoucher Type",
			dataIndex: "eVoucherType",
			align: "center"
		},
		{
			title: <MDCustomSearchFilterIcon infoItem={record} />,
			dataIndex: "filter",
			align: "center"
		}
	];
};
